import { FC, useMemo } from "react";
import { useSelector } from "react-redux";

import { eventBlockSelectorCreator } from "Bands/state";
import { EventUniqueBlocks, IVenueBlock } from "Bands/types";
import { VenueTeaser } from "Venues/components";
import { IStage } from "Venues/types";
import { useEventContext } from "Bands/contexts";

interface EventVenueBlockProps {
  blockId: string;
}

export const EventVenueBlock: FC<EventVenueBlockProps> = ({ blockId }) => {
  const venueBlockSelector = eventBlockSelectorCreator(blockId, EventUniqueBlocks.venue);
  const venueBlock = useSelector(venueBlockSelector) as IVenueBlock;
  const { eventId } = useEventContext();

  const stages: IStage[] | undefined = useMemo(
    () =>
      venueBlock.stage
        ? [
            {
              ...venueBlock.stage,
              stageCapacities: venueBlock.stageCapacity ? [venueBlock.stageCapacity] : undefined,
            },
          ]
        : undefined,
    [venueBlock.stage, venueBlock.stageCapacity]
  );

  if (!eventId) return null;

  return (
    <VenueTeaser {...venueBlock.venue} showMap hideContainer stages={stages} eventId={eventId} />
  );
};
